import React, { memo } from 'react'

const Separator = function ({ style = {} }) {
  return (
    <div
      style={{
        width: '2px',
        height: '25px',
        background: 'rgba(147,154,163,0.20)',
        ...style,
      }}
    />
  )
}

export default memo(Separator)
